import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEAerospaceCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Aerospace Engineering",
    shortName: "B.E. Aerospace",
    duration: "4 years",
    description: "Specialized engineering program focused on design, development, and manufacturing of aircraft and spacecraft systems",
    overview: "Bachelor of Engineering in Aerospace Engineering (B.E. Aerospace) is a 4-year undergraduate program that deals with the design, development, testing, and production of aircraft, spacecraft, and related systems. This prestigious course covers aerodynamics, propulsion, structures, and control systems for both atmospheric and space flight vehicles, preparing students for careers in aviation and space industries.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Strong foundation in mathematics and physics"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Introduction to Aerospace",
          "Computer Programming"
        ]
      },
      {
        year: 2,
        subjects: [
          "Mechanics of Materials",
          "Thermodynamics",
          "Fluid Mechanics",
          "Materials Science",
          "Aerospace Structures",
          "Engineering Mathematics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Aerodynamics",
          "Aircraft Propulsion",
          "Flight Mechanics",
          "Aerospace Control Systems",
          "Spacecraft Design",
          "Computational Fluid Dynamics"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced Aerospace Systems",
          "Satellite Technology",
          "Rocket Propulsion",
          "Aircraft Design Project",
          "Space Mission Design",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Aerospace Engineer",
        "Aircraft Design Engineer",
        "Propulsion Engineer",
        "Flight Test Engineer",
        "Spacecraft Systems Engineer",
        "Aerodynamics Engineer",
        "Mission Planning Engineer",
        "Research Scientist"
      ],
      industries: [
        "Indian Space Research Organisation (ISRO)",
        "Defence Research and Development Organisation (DRDO)",
        "Hindustan Aeronautics Limited (HAL)",
        "Air India Engineering Services",
        "Private Aerospace Companies",
        "Airlines (Maintenance)",
        "NASA (International opportunities)",
        "Boeing, Airbus (International)"
      ],
      averageSalary: "₹8-18 LPA (Fresher), ₹25-80 LPA (Experienced)",
      topRecruiters: [
        "ISRO, DRDO, HAL",
        "Air India, IndiGo",
        "Tata Advanced Systems",
        "Boeing, Airbus",
        "Rolls-Royce, GE Aviation",
        "SpaceX, Blue Origin (International)"
      ]
    },

    admissionProcess: [
      "JEE Advanced (for IITs)",
      "JEE Main (for NITs and other central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "IIST Admission Test (for space technology)"
    ],

    topColleges: [
      {
        name: "Indian Institute of Technology (IIT) Bombay",
        location: "Mumbai",
        fees: "₹8,00,000",
        ranking: "NIRF Ranking: 3"
      },
      {
        name: "Indian Institute of Technology (IIT) Kanpur",
        location: "Kanpur",
        fees: "₹8,00,000",
        ranking: "NIRF Ranking: 4"
      },
      {
        name: "Indian Institute of Space Science and Technology (IIST)",
        location: "Thiruvananthapuram",
        fees: "₹5,40,000",
        ranking: "NIRF Ranking: 46"
      },
      {
        name: "Madras Institute of Technology, Anna University",
        location: "Chennai",
        fees: "₹2,20,000",
        ranking: "NIRF Ranking: 48"
      }
    ],

    skills: [
      "Aerodynamics Analysis",
      "CAD/CAE Software (CATIA, SolidWorks)",
      "MATLAB/Simulink",
      "Computational Fluid Dynamics",
      "Flight Simulation",
      "Propulsion Systems Design",
      "Structural Analysis",
      "Project Management",
      "Research and Development",
      "Problem Solving"
    ],

    futureScope: "Excellent prospects with India's growing space program, expanding aviation sector, and global opportunities in commercial space exploration and advanced aircraft development.",

    faqs: [
      {
        question: "What is the difference between Aerospace and Aeronautical Engineering?",
        answer: "Aerospace Engineering covers both aircraft (aeronautical) and spacecraft (astronautical) systems, while Aeronautical focuses specifically on aircraft within Earth's atmosphere."
      },
      {
        question: "Can I join ISRO after this course?",
        answer: "Yes, ISRO regularly recruits Aerospace Engineers through ISRO Centralized Recruitment Board (ICRB) examinations for scientist and engineer positions."
      },
      {
        question: "Are there opportunities abroad?",
        answer: "Yes, major aerospace companies like Boeing, Airbus, NASA, SpaceX, and others actively recruit Indian aerospace engineers for global projects."
      },
      {
        question: "What about higher studies options?",
        answer: "Excellent options for M.S./Ph.D. in Aerospace Engineering at IITs, IISc, or international universities like MIT, Stanford, and Caltech."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEAerospaceCoursePage;
